import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";


const BASE_URL = "https://sutmmgdev.codydeasoftech.in/api";

const SizeMaster = () => {
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ item_id: "" });
 const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
      const [totalRecords, setTotalRecords] = useState(0);
      const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  const fetchSizesList = async (page = 1,searchValue= filters.item_id) => {
  setLoading(true);
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/sizesList`,
     {
        item_id: searchValue,
        page: page,
        per_page: perPage
    },{

      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setSizes(res.data.data || []);
    setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
      Math.ceil(
        (res.data.total_records || 0) /
        (res.data.per_page || perPage)
      )
    );
  } catch (error) {
    console.error("Fetch Items Error:", error);

    if (error.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      navigate("/suda/login");
    }
  } finally {
    setLoading(false);
  }
};

const sizeFields = [
//   { label: "Size", key: "size" },
  { label: "Length", key: "length" },
  { label: "Chest", key: "chest" },
  { label: "Shoulder", key: "shoulder" },
  { label: "Sleeve Length", key: "sleeve_length" },
  { label: "Sleeve Opening", key: "sleeve_opening" },
  { label: "Round Neck", key: "round_neck" },
  { label: "Waist", key: "waist" },
  { label: "Thigh", key: "thigh" },
  { label: "Inseam", key: "inseam" },
  { label: "Bottom", key: "bottom" },
  { label: "Crotch", key: "crotch" },
  { label: "Bust", key: "bust" },
  { label: "Hip", key: "hip" },
  { label: "Neck Depth", key: "neck_depth" },
  { label: "HPS to Waist", key: "hps_to_waist" },
  { label: "Armhole", key: "armhole" },
];



 const fetchItemsList = async() => {
    try{
const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/itemsList`,{},
     {

      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
        setItems(res.data.data.itemsList || []);

    }catch(err){
        console.log(err);
    }
 }


 const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};

  useEffect(() => {
    fetchItemsList();
  }, []);


        useEffect(() => { fetchSizesList(1); }, [perPage]);


  return (
    <div className="container mt-4" style={{ maxWidth: 1300 }}>
      {/* 🔷 Header */}
       <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Size Master
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
            <Row className="align-items-center">
          <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold">Items</Form.Label>
    <Form.Select
      value={filters.item_id}
      onChange={(e) =>
        setFilters({ ...filters, item_id: e.target.value })
      }
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">Selct Item</option>
      {items.map((g) => (
        <option key={g.id} value={g.id}>
          {g.item_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>


          <Col md={3}>
                           <Form.Group className="mb-3">
                                           <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                               <Form.Select
                                style={{
                                               borderRadius: "10px",
                                               border: "2px solid #1565C1",
                                             }}
                                 value={perPage}
                                 onChange={(e) => {
                                   const value = Number(e.target.value);
                                   setPerPage(value);
                                   setPage(1);

                                 }}

                               >
                                 <option value={10}>10 Per Page</option>
                                       <option value={25}>25 Per Page</option>
                                       <option value={50}>50 Per Page</option>
                                       <option value={100}>100 Per Page</option>
                               </Form.Select>
                               </Form.Group>
                           </Col>

                           {/* ✅ BUTTONS */}
                           <Col md={4} className="d-flex gap-3 mt-3">
                             {/* SEARCH */}
                             <Button
                               className="w-50 fw-semibold text-white"
                               style={{
                                 background: "#1565C1",
                                 border: "none",
                                 borderRadius: "10px",
                                 transition: "0.3s",
                               }}
                               onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                               onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                               onClick={() => fetchSizesList(1, filters.item_id)}
                             >
                               <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                             </Button>

                             {/* RESET */}
                             <Button
  className="w-50 fw-semibold text-white"
  style={{
    background: "#E53935",
    border: "none",
    borderRadius: "10px",
    transition: "0.3s",
  }}
  onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
  onMouseLeave={(e) => (e.target.style.background = "#E53935")}
  onClick={() => {
    setFilters({ item_id: "" });
    setPage(1);
    setPerPage(10);
    fetchSizesList(1, ""); // ✅ fetch fresh data after reset
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
</Button>

                           </Col>
        </Row>
        </Card.Body>
      </Card>



        {loading && (
        <div className="loader-wrapper">
            <div className="blue-spinner"></div>

            <div className="loading-line">
            <div className="loading-progress"></div>
            </div>

            <p className="loading-text">Loading, please wait...</p>
        </div>
        )}
      {/* 📄 TABLE */}
      {!loading && (

      <Card className="mb-4 border-0"
              style={{
                  background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
                  boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
                  overflow: "hidden",
              }}>
              <Table bordered hover responsive striped>
          <thead>
  <tr>
    <th className="text-center" style={{ width: "80px" ,padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",}}>SL No.</th>
    <th className="text-center" style={{ width: "220px",padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center", }}>Item Name</th>
                  <th className="text-center" style={{ width: "80px",padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center", }}>Size</th>
    <th className="text-center" style={{
        padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
    }}>Size Details</th>
  </tr>
</thead>


          <tbody>
  {sizes.length > 0 ? (
    sizes.map((row, index) => (
      <tr key={row.id}>
        {/* SL NO */}
        <td className="text-center">
          {(page - 1) * perPage + index + 1}
        </td>

        {/* ITEM NAME */}
        <td className="text-center fw-semibold">
          {row.item_name}
        </td>
        <td className="text-center fw-semibold">
          {row.size}
        </td>

        {/* DETAILS COLUMN */}
        <td className="text-center">
  <div className="d-flex flex-wrap gap-3">
    {sizeFields.map(({ label, key }) =>
      row[key] ? (
        <span key={key}>
          <b>{label}:</b> {row[key]} inch
        </span>
      ) : null
    )}
  </div>
</td>

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="3" className="text-center text-muted py-4">
        No Data Found
      </td>
    </tr>
  )}
</tbody>


        </Table>
      </Card>


      )}

       {
    totalPages > 1 && (
         <div className="d-flex justify-content-center mt-4">
        <nav>
            <ul className="pagination shadow-sm">

            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchSizesList(1)}>
                «
                </button>
            </li>

            {/* Prev */}
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchSizesList(page - 1)}>
                ‹
                </button>
            </li>

            {/* Page Numbers */}
            {getPageNumbers().map((p) => (
                <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                <button className="page-link" onClick={() => fetchSizesList(p)}>
                    {p}
                </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchSizesList(page + 1)}>
                ›
                </button>
            </li>

            {/* Last */}
            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchSizesList(totalPages)}>
                »
                </button>
            </li>

            </ul>
        </nav>
    </div>
    )
   }


    </div>
  );
};

export default SizeMaster;
